import { isEmpty } from 'lodash';

import {
    REQUEST_PARTNERS,
    RECEIVE_PARTNERS,
    FAILURE_PARTNERS,
    REQUEST_PARTNER_DETAILS,
    RECEIVE_PARTNER_DETAILS,
    FAILURE_PARTNER_DETAILS,
    REQUEST_OFFLINE_PARTNER,
    RECEIVE_OFFLINE_PARTNER,
    FAILURE_OFFLINE_PARTNER
} from './constants';

import { CALL_API } from '../../middlewares/api';

const shouldFetchPartners = state => {
    const partners = state.partner.partners;
    const fetching = state.partner.fetching;

    if (fetching) {
        return false;
    } else if (isEmpty(partners)) {
        return true;
    } else {
        return false;
    }
};

export const fetchPartnersIfNeeded = () => {
    return {
        [CALL_API]: {
            endpoint: '/partner',
            types: [REQUEST_PARTNERS, RECEIVE_PARTNERS, FAILURE_PARTNERS],
            shouldCallAPI: state => shouldFetchPartners(state)
        }
    };
};

export const forceFetchPartners = () => {
    return {
        [CALL_API]: {
            endpoint: '/partner',
            types: [REQUEST_PARTNERS, RECEIVE_PARTNERS, FAILURE_PARTNERS]
        }
    };
};

const shouldFetchPartnerDetails = (id, state) => {
    const partner = state.partner.partners[id];
    const fetching = partner && state.partner.partners[id].fetching;

    if (fetching) {
        return false;
    } else if (!partner || (!partner.description && !partner.detailsFetched)) {
        return true;
    } else {
        return false;
    }
};

export const fetchPartnerDetailsIfNeeded = (id, lazy = true) => {
    return {
        [CALL_API]: {
            endpoint: `/partner/${id}${lazy ? '/lazy' : ''}`,
            payload: { id },
            types: [REQUEST_PARTNER_DETAILS, RECEIVE_PARTNER_DETAILS, FAILURE_PARTNER_DETAILS],
            shouldCallAPI: state => shouldFetchPartnerDetails(id, state)
        }
    };
};

const shouldFetchOfflinePartner = (state, id) => {
    if (!id) {
        return;
    }

    const fetching = state.partner.offlineFetching;

    if (fetching) {
        return false;
    } else {
        return true;
    }
};

export const fetchOfflinePartnerIfNeeded = id => {
    return {
        [CALL_API]: {
            endpoint: `/partner/${id}/offline`,
            types: [REQUEST_OFFLINE_PARTNER, RECEIVE_OFFLINE_PARTNER, FAILURE_OFFLINE_PARTNER],
            shouldCallAPI: state => shouldFetchOfflinePartner(state, id)
        }
    };
};



// WEBPACK FOOTER //
// ./src/services/partner/actions.js